import { put, takeLatest } from "redux-saga/effects";
import { httpGet, httpPost } from "../../services";
import {
  getSigningKeysRequest,
  getSigningKeysSuccess,
  getSigningKeysError,
  rotateSigningKeyRequest,
  rotateSigningKeySuccess,
  rotateSigningKeyError,
  rotateNRevokeSigningKeyRequest,
  rotateNRevokeSigningKeySuccess,
  rotateNRevokeSigningKeyError,
  createAppSigningKeyRequest,
  createAppSigningKeySuccess,
  createAppSigningKeyError,
  rotateAppSigningKeyRequest,
  rotateAppSigningKeySuccess,
  rotateAppSigningKeyError
} from "../features/settings/signingKeys";

function* getSigningKeysHandler() {
  try {
    const response: any = yield httpGet("/platform-configuration/signing-keys");
    if (response && !response.ErrorCode) {
      yield put(getSigningKeysSuccess(response));
    } else if (response && response.ErrorCode) {
      throw new Error(response.Description || "Failed to fetch signing keys.");
    }
  } catch (e: any) {
    yield put(getSigningKeysError(e.message || "An error occurred while fetching signing keys."));
  }
}

function* rotateSigningKeyHandler() {
  try {
    const response: any = yield httpPost("/platform-configuration/signing-keys/rotate", {});
    if (response && !response.ErrorCode) {
      yield put(rotateSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to rotate signing keys");
    }
  } catch (e: any) {
    yield put(rotateSigningKeyError(e.message || "An error occurred while rotating signing keys"));
  }
}

function* rotateNRevokeSigningKeyHandler() {
  try {
    const response: any = yield httpPost("/platform-configuration/signing-keys/revoke", {});
    if (response && !response.ErrorCode) {
      yield put(rotateNRevokeSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to rotate and revoke signing keys");
    }
  } catch (e: any) {
    yield put(rotateNRevokeSigningKeyError(e.message || "An error occurred while rotating and revoking signing keys."));
  }
}

function* createAppSigningKeyHandler(action: ReturnType<typeof createAppSigningKeyRequest>) {
  try {
    const { clientName } = action.payload;
    const response: any = yield httpPost(`/platform-configuration/signing-keys/app/${clientName}`, {});
    if (response && !response.ErrorCode) {
      yield put(createAppSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to create app signing key");
    }
  } catch (e: any) {
    yield put(createAppSigningKeyError(e.message || "An error occurred while creating app signing key"));
  }
}

function* rotateAppSigningKeyHandler(action: ReturnType<typeof rotateAppSigningKeyRequest>) {
  try {
    const { clientName } = action.payload;
    const response: any = yield httpPost(`/platform-configuration/signing-keys/app/${clientName}/rotate`, {});
    if (response && !response.ErrorCode) {
      yield put(rotateAppSigningKeySuccess());
      yield put(getSigningKeysRequest());
    } else {
      throw new Error(response?.Description || "Failed to rotate app signing key");
    }
  } catch (e: any) {
    yield put(rotateAppSigningKeyError(e.message || "An error occurred while rotating app signing key"));
  }
}

export function* watchSigningKeys() {
  yield takeLatest(getSigningKeysRequest.type, getSigningKeysHandler);
  yield takeLatest(rotateSigningKeyRequest.type, rotateSigningKeyHandler);
  yield takeLatest(rotateNRevokeSigningKeyRequest.type, rotateNRevokeSigningKeyHandler);
}

export function* watchAppSigningKeys() {
  yield takeLatest(createAppSigningKeyRequest.type, createAppSigningKeyHandler);
  yield takeLatest(rotateAppSigningKeyRequest.type, rotateAppSigningKeyHandler);
}
